<template>
  <section v-if="title" class="cx-sec m-mak-and-greet" :class="{ 'bnw-gray': blackAndWhite }">
    <div class="cx-wrap--page m-wrap--page">
      <div class="cx-row">
        <div class="cx-col-md-12 cx-col-sm-12 cx-div">
          <h2 class="cx-t20 m-mak-and-greet__title">{{ title }}</h2>
        </div>
      </div>
      <div class="m-mak-and-greet__container">
        <img class="mak-and-greet-sign" src="/static/images/home/MakMak.svg" alt="" />
        <img class="mak-and-greet" src="/static/images/home/MakMak2.png" width="1123" height="933" alt="" />
      </div>
      <div class="m-mak-and-greet__desc">
        <p class="cx-t01">{{ desc }}</p>
      </div>
      <ul v-if="sections.length > 0" class="m-mak-and-greet__links">
        <li v-for="(section, i) in sections" :key="i" style="flex-shrink: 0; min-width: 20%;" :style="sections.length > 0 ? `width: ${(100/sections.length)}%` : ''">
          <router-link-localed :to="section.link">
            <span class="mak-and-greet-link-icon-wrapper">
              <span class="mak-and-greet-link-icon" :style="`color: ${section.color}; background-color: ${section.color + '25'};`">
                <i :style="`--fa-primary-color: ${section.color}; --fa-secondary-color: ${section.color};`" :class="section.iconClass"></i>
              </span>
            </span>
            <span class="cx-t20">{{ section.label }}</span>
          </router-link-localed>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'home-mak-and-greet',
  uit() {
    return [
      ['makAndGreet', [
        'title',
        'desc',
        'link',
        'sections',
        'section1Id', 'section1Label', 'section1Color', 'section1Icon',
        'section2Id', 'section2Label', 'section2Color', 'section2Icon',
        'section3Id', 'section3Label', 'section3Color', 'section3Icon',
        'section4Id', 'section4Label', 'section4Color', 'section4Icon',
        'section5Id', 'section5Label', 'section5Color', 'section5Icon',
        'section6Id', 'section6Label', 'section6Color', 'section6Icon',
        'section7Id', 'section7Label', 'section7Color', 'section7Icon',
        'section8Id', 'section8Label', 'section8Color', 'section8Icon',
        'section9Id', 'section9Label', 'section9Color', 'section9Icon',
        'section10Id', 'section10Label', 'section10Color', 'section10Icon',
      ]]
    ]
  },
  computed: {
    ...mapState({
      blackAndWhite: state => state.ui.blackAndWhite,
    }),
    title() {
      return this.$t('makAndGreet.title') || '';
    },
    desc() {
      return this.$t('makAndGreet.desc') || '';
    },
    link() {
      return this.$t('makAndGreet.link') || '';
    },
    sections() {
      const count = Number(this.$t('makAndGreet.sections') || 0);
      // UIT declares ten sections; missing/non-numeric data must not allocate an invalid array.
      const length = Number.isSafeInteger(count) && count > 0 ? Math.min(count, 10) : 0;
      return new Array(length).fill(null).map((_, i) => {
        const n = i + 1;
        const id = this.$t(`makAndGreet.section${n}Id`) || '';
        const label = this.$t(`makAndGreet.section${n}Label`) || '';
        const color = this.$t(`makAndGreet.section${n}Color`) || '';
        const iconClass = this.normalizeDuotoneIconClass(this.$t(`makAndGreet.section${n}Icon`) || '');
        const link = this.link + (id ? `#${id}` : '');
        return { id, label, color, iconClass, link };
      });
    },
  },
  methods: {
    normalizeDuotoneIconClass(iconClass) {
      const raw = String(iconClass || '')
        .replace(/,/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
      if (!raw) {
        return '';
      }

      const hasStyleClass = /\b(fa-(?:solid|regular|light|duotone|brands|thin)|fas|far|fal|fad|fab|fat)\b/.test(raw);
      if (!hasStyleClass) {
        return `fa-duotone ${raw}`;
      }
      return raw;
    },
  },
}
</script>

<style lang="scss">
.m-mak-and-greet {
  .m-wrap--page {
    position: relative;
    display: flex;
    flex-direction: column;
  }

  background-color: #F9F7F4;
  border-bottom: 1px solid rgba(162, 162, 162, 0.2);

  &__title{
    @extend %style-title;
  }

  &__container {
    position: relative;
    margin: 0 -1rem;

    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    overflow: hidden;

    img.mak-and-greet-sign {
      position: absolute;
      top: 1rem;
      min-width: 500px;
      max-width: 1500px;
      width: calc(100% - 2rem);
      height: auto;
      margin: 0 auto;
    }
    img.mak-and-greet {
      position: relative;
      z-index: 2;
      min-width: 400px;
      width: 40%;
      height: auto;
      margin: 0 auto;
    }

    &::after {
      content: '';
      display: block;
      position: absolute;
      height: 25%;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 2;
      background: linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(249,247,244,1) 100%);
    }
  }

  &__desc {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1;
    margin-top: 1rem;
    max-width: 45%;
    padding: 1rem 2rem;
    border: 2px dashed #000;
    border-radius: 999px;
    background-color: rgba(255, 255, 255, 0.7);

    p {
      text-align: center;
      position: relative;
      z-index: 1;
      &.cx-t01 {
        font-size: $font-md;
      }
    }

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 100%;
      margin-top: calc(10% + 0.5vw);
      z-index: 0;
      display: block;
      width: calc(27.5% + 1vw);
      height: 1px;
      border-bottom: 2px dashed #000;
      transform: translateX(-65%) rotate(135deg);
    }
  }

  &__links {
    list-style: none;
    min-width: Min(900px, 100%);
    // width: 80%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    position: relative;
    z-index: 3;
    padding: 1.5rem;
    padding-top: 2rem;
    padding-bottom: 0;
    margin: 0 auto;
    margin-top: -5.5%;

    li {
      padding: 1.5rem;
      padding-bottom: 1rem;

      a {
        display: inline-flex;
        width: 100%;
        flex-direction: column;
        align-items: center;
        text-align: center;
        &:not(:hover) {
          color: #3D4649;
        }
        .cx-t20 {
          font-size: $font-md;
        }

        .mak-and-greet-link-icon-wrapper {
          position: relative;
          display: inline-flex;
          justify-content: center;
          align-items: center;
          border-radius: 50%;
          padding: 0.75rem;
          background: linear-gradient(180deg, #FFFFFF 24.48%, rgba(255, 255, 255, 0) 100%);
          &::before {
            content: '';
            position: absolute;
            top: 1rem;
            right: 1rem;
            bottom: 1rem;
            left: 1rem;
            border-radius: 50%;
            background-color: #FFFFFF;
          }
        }
        .mak-and-greet-link-icon {
          position: relative;
          display: inline-flex;
          justify-content: center;
          align-items: center;
          font-size: 4rem;
          width: 8rem;
          height: 8rem;
          border-radius: 50%;
          border: 0.25rem solid rgba(255, 255, 255, 0.9);
        }
      }
    }
  }

}

@media (min-width: $breakpoint-xl) {
  .m-mak-and-greet {
    .m-wrap--page {
      display: block;
    }
    
    padding-bottom: 2rem;

    &__container {
      img.mak-and-greet-sign {
        top: 0;
      }
    }

    &__links {
      width: 80%;
      // padding: 0;
      padding-bottom: 1.5rem;

      // position: absolute;
      // margin-top: -21.5%;
      // left: 50%;
      // transform: translateX(-50%);

      // li {
      //   width: auto !important;
      //   max-width: 15.3rem;
      // }
      // li:nth-child(1) {
      //   margin-left: -1.5rem;
      // }
      // li:nth-child(2) {
      //   margin-left: -0.5rem;
      //   margin-right: auto;
      // }
      // li:nth-child(3) {
      //   margin-left: auto;
      //   margin-right: -0.5rem;
      // }
      // li:nth-child(4) {
      //   margin-right: -1.5rem;
      // }
    }
  }
}

@media (max-width: $breakpoint-lg) {
  .m-mak-and-greet {
    &__container {
      order: 2;
    }

    &__desc {
      order: 1;

      position: relative;
      left: 0;
      margin: 1rem auto;
      margin-bottom: -5%;
      max-width: max-content;
      width: 85%;
      padding: 1rem 2rem;

      &::before {
        content: none;
      }
    }

    &__links {
      order: 3;

      width: 50%;
      padding: 0;

      margin-top: -2.5%;

      li {
        width: 33% !important;
      }
    }
  }
}
@media (max-width: $breakpoint-md) {
  .m-mak-and-greet {
    &__container {
      img.mak-and-greet-sign {
        top: 0;
      }
    }

    &__desc {
      width: 90%;
      padding: 1.5rem 1.5rem;
      margin-bottom: -6%;
    }

    &__links {
      min-width: Min(450px, 90%);
      width: 65%;
      padding: 0;

      margin-top: -2.5%;

      li {
        width: 50% !important;
      }
    }
  }
}
@media (max-width: $breakpoint-sm) {
  .m-mak-and-greet {
    &__container {
      img.mak-and-greet-sign {
        min-width: calc(100vw - 2rem);
        width: calc(100% - 2rem);
      }
    }

    &__desc {
      width: 100%;
      padding: 1.25rem 1.75rem;
      margin-bottom: -7%;
      border-radius: 66px;
    }

    &__links {
      min-width: Min(390px, 90%);
      width: 80%;
      padding: 0;

      margin-top: -7.5%;

      li {
        width: 50% !important;

        a {
          .mak-and-greet-link-icon {
            font-size: 2.75rem;
            width: 6rem;
            height: 6rem;
          }
        }
      }
    }
  }
}
</style>
